export const equalPasswords = (
  value: string,
  allValues: { plainPassword: string },
) => {
  if ((allValues.plainPassword || value) && value !== allValues.plainPassword) {
    return "Passwords do not match";
  }
};
